import RecHomeNavbar from "../../RecHomeNavbar";
import { Header } from "./components/Header";
import { SearchBar } from "./components/SearchBar";
import { TalentList } from "./components/TalentList";

export default function RecHome() {
    return (
        <>
            <RecHomeNavbar />
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900 mt-14 flex flex-col px-8 py-10">
            <Header />
            {/* <SearchBar /> */}
            <TalentList />
            </div>
        </>
    );
}